export class LanguageModel {
    id: number;
    iso: string;
    description: string;
    languageImage: string;
}